import { render, staticRenderFns } from "./Reg.vue?vue&type=template&id=55a6fce3&scoped=true"
import script from "./Reg.vue?vue&type=script&lang=js"
export * from "./Reg.vue?vue&type=script&lang=js"
import style0 from "./Reg.vue?vue&type=style&index=0&id=55a6fce3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a6fce3",
  null
  
)

export default component.exports